// ================================================
// === Hide Header on Scroll Down / Show Near Top Functionality
// ================================================
let lastScrollTop = 0; // Variable to store the last scroll position
const headerWrapper = document.querySelector('sticky-header.header-wrapper'); // Target the header
const hideThreshold = 50;  // How many pixels to scroll down before hiding starts
const showNearTopThreshold = 100; // How close to the top (in px) to scroll before showing again

window.addEventListener('scroll', function() {
    if (!headerWrapper) return; // Exit if header not found

    let currentScrollTop = window.scrollY || document.documentElement.scrollTop;

    if (currentScrollTop > lastScrollTop && currentScrollTop > hideThreshold) {
        // Scrolling Down PAST the threshold - Hide header
        headerWrapper.classList.add('header--hidden');
    } else if (currentScrollTop < showNearTopThreshold) {
        // Scrolling Up AND near the top - Show header
        // This also covers the case when scroll is exactly 0
        headerWrapper.classList.remove('header--hidden');
    }
    // Note: If scrolling up but not near the top, the state (hidden) remains unchanged.

    // Update lastScrollTop for the next event, ensuring it's not negative
    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;

}, false);
// === END Hide Header Functionality ===

// ================================================
// === Sticky Add To Cart Bar Functionality ===
// ================================================
const stickyBar = document.getElementById('sticky-cart-bar');
const ingredientsSection = document.querySelector('.ingredients-section');
const offerSection = document.querySelector('.offer-section');

let ingredientsSectionTop = 0;
let offerSectionTop = Infinity;

function updateTriggerPositions() {
    // Recalculate positions on load/resize if layout changes
    // Ensure elements exist before getting properties
    if (ingredientsSection) {
        ingredientsSectionTop = window.scrollY + ingredientsSection.getBoundingClientRect().top;
    } else {
        console.warn("Ingredients section not found for sticky bar trigger.");
        ingredientsSectionTop = 0; // Default or fallback
    }

    if (offerSection) {
        offerSectionTop = window.scrollY + offerSection.getBoundingClientRect().top;
    } else {
        console.warn("Offer section not found for sticky bar trigger.");
        offerSectionTop = document.body.scrollHeight; // Fallback to bottom of page
    }
}

function handleStickyBarScroll() {
    if (!stickyBar || !ingredientsSection || !offerSection) return; // Exit if elements not found

    const scrollY = window.scrollY;
    const barHeight = stickyBar.offsetHeight || 80; // Estimate height if not rendered yet
    const windowHeight = window.innerHeight;
    const hidePosition = offerSectionTop - windowHeight + barHeight;
    const shouldBeVisible = scrollY > ingredientsSectionTop && scrollY < hidePosition;

    if (shouldBeVisible) {
        stickyBar.classList.add('is-visible');
    } else {
        stickyBar.classList.remove('is-visible');
    }
}
// === END Sticky Add To Cart Bar Functionality ===


// Basic Tab Switching (for Mobile/Tablet Product Details)
function openTab(evt, tabId) {
     if (!evt || !evt.currentTarget || !tabId) {
         console.error('Missing event or tabId for tab switching.');
         return;
     }
     const targetElement = document.getElementById(tabId);
     if (!targetElement) {
          console.error('Target tab content element not found:', tabId);
          return;
     }
     const descriptionTabsContainer = targetElement.closest('.description-tabs');
     if (!descriptionTabsContainer) return; // Exit if container not found

     // Hide all tab content panels within this specific tab group
     descriptionTabsContainer.querySelectorAll('.product_meta-outer').forEach(tab => {
         tab.classList.remove('tab-content-active');
     });
     // Deactivate all tab buttons within the corresponding container
     const buttonContainer = evt.currentTarget.closest('#tab-button-container');
     if (buttonContainer) {
          buttonContainer.querySelectorAll('.tab-button').forEach(btn => {
             btn.classList.remove('tab-active');
         });
     }

     // Activate the target tab content and button
     targetElement.classList.add('tab-content-active');
     evt.currentTarget.classList.add('tab-active');
}


document.addEventListener('DOMContentLoaded', () => {

    // --- Sticky Bar Setup ---
    updateTriggerPositions(); // Calculate positions after DOM is ready
    window.addEventListener('scroll', handleStickyBarScroll, { passive: true }); // Use passive listener
    window.addEventListener('resize', updateTriggerPositions); // Recalculate on resize


    // --- Smooth Scrolling ---
    // Combine selectors for efficiency
    const smoothScrollLinks = document.querySelectorAll('.sticky-bar-button, .results-cta-button');
    smoothScrollLinks.forEach(link => {
        if (link) {
            link.addEventListener('click', function(event) {
                event.preventDefault();
                const targetId = this.getAttribute('href');
                if (targetId && targetId.startsWith('#')) {
                    const targetElement = document.getElementById(targetId.substring(1));
                    if (targetElement) {
                        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    } else {
                        console.warn('Smooth scroll target element not found:', targetId);
                    }
                } else {
                    console.warn('Smooth scroll link href is not a valid ID link:', targetId);
                }
            });
        }
    });


    // --- Mobile/Tablet Product Tab Setup ---
    const tabButtonContainer = document.getElementById('tab-button-container');
    if (tabButtonContainer) { // Check if the tab container exists first
        const firstTabButton = tabButtonContainer.querySelector('.tab-button');
        if (firstTabButton) {
            // Activate first tab only if the container is visible (i.e., not on desktop)
            if (window.getComputedStyle(tabButtonContainer).display !== 'none') {
                const firstTabTargetId = firstTabButton.dataset.tabTarget;
                if (firstTabTargetId) {
                    const firstTabContent = document.getElementById(firstTabTargetId);
                    if (firstTabContent) {
                        const tabContainer = firstTabContent.closest('.description-tabs');
                        if(tabContainer){
                            tabContainer.querySelectorAll('.product_meta-outer').forEach(tab => {
                                tab.classList.remove('tab-content-active');
                            });
                            firstTabContent.classList.add('tab-content-active');
                        }
                        tabButtonContainer.querySelectorAll('.tab-button').forEach(btn => btn.classList.remove('tab-active'));
                        firstTabButton.classList.add('tab-active');
                    } else { console.warn('Default tab content not found for ID:', firstTabTargetId); }
                } else { console.warn('First tab button missing data-tab-target attribute.'); }
            }
        } else {
            // console.warn('No tab buttons found in #tab-button-container.'); // Less verbose
        }
        // Add click listeners
        tabButtonContainer.querySelectorAll('.tab-button').forEach(button => {
            button.addEventListener('click', (event) => {
                const targetTabId = button.dataset.tabTarget;
                if (targetTabId) {
                    openTab(event, targetTabId);
                } else { console.error('Tab button missing data-tab-target attribute.'); }
            });
        });
    } // End if(tabButtonContainer)

    // --- FAQ Accordion Setup ---
    const faqAccordionContainer = document.querySelector('.faq-accordion-container');
    if (faqAccordionContainer) {
    const faqButtons = faqAccordionContainer.querySelectorAll('.faq-accordion-button');

    // init all closed
    faqButtons.forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
        const cnt = btn.nextElementSibling;
        if (cnt?.classList.contains('faq-accordion-content')) cnt.style.display = 'none';
    });

    faqButtons.forEach(button => {
        button.addEventListener('click', () => {
        const content = button.nextElementSibling;
        if (!content?.classList.contains('faq-accordion-content')) return;

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
            // close this one
            button.setAttribute('aria-expanded', 'false');
            content.style.display = 'none';
        } else {
            // close all then open clicked
            faqButtons.forEach(btn => {
            btn.setAttribute('aria-expanded', 'false');
            const cnt = btn.nextElementSibling;
            if (cnt?.classList.contains('faq-accordion-content')) cnt.style.display = 'none';
            });
            button.setAttribute('aria-expanded', 'true');
            content.style.display = 'block';
        }
        });
    });
    }
    // End if(faqAccordionContainer)

	// ========================================================
    // === Real-time Input Validation for Name and Phone ===
    // ========================================================
    const nameInputs = document.querySelectorAll(
        '#customer_name, #desktop_customer_name, #offer_ff_name'
    );
    const phoneInputs = document.querySelectorAll(
        '#customer_phone, #desktop_customer_phone, #offer_ff_phone'
    );

    const validationClass = 'input-valid';
    const nameMinLength = 3;
    const phoneMinDigits = 5;

    function handleValidation(inputElement, minLength, checkDigits = false) {
        const value = inputElement.value;
        let isValid = false;

        if (checkDigits) {
            // Count only digits for phone
            const digitCount = (value.match(/\d/g) || []).length;
            isValid = digitCount >= minLength;
        } else {
            // Check trimmed length for name
            isValid = value.trim().length >= minLength;
        }

        if (isValid) {
            inputElement.classList.add(validationClass);
        } else {
            inputElement.classList.remove(validationClass);
        }
    }

    nameInputs.forEach(input => {
        if (input) {
            input.addEventListener('input', () => {
                handleValidation(input, nameMinLength);
            });
            // Optional: Run validation once on load in case of pre-filled values
            // handleValidation(input, nameMinLength);
        }
    });

    phoneInputs.forEach(input => {
        if (input) {
            input.addEventListener('input', () => {
                handleValidation(input, phoneMinDigits, true); // Check for digits
            });
            // Optional: Run validation once on load
            // handleValidation(input, phoneMinDigits, true);
        }
    });
    // === END Real-time Input Validation ===
 }); // End DOMContentLoaded